import { useState } from 'react';
import { useSelector } from 'react-redux';
import { apiurl } from '../../utils/constants';
import { sendMail, log } from '../../utils/functions';

function RejeInvo({ bill, onClose, onRefresh }) {

	const { iden: iuser, mail, sapDB } = useSelector((state) => state.user);
	const [reas, setReas] = useState('');
	const [error, setError] = useState('');

	const declineInvo = async () => {

		if (!reas) {
			setError('Debe ingresar una razón para rechazar la factura.');
			alert('Debe ingresar una razón para rechazar la factura.');
			return;
		}

		setError('');

		try {
			const response = await fetch(apiurl + `queryAux`, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB,
					user: mail,
					query: `UPDATE bil__form SET rejected=now(),rejector= ${iuser},reason= '${reas}' WHERE docu = ${bill}`
				})
			});
			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			log('mod', 'soli', bill, mail, iuser, `rejected via web`);

			let body = `
					Se ha rechazado la factura ${bill}.
					<br>
					Puede ver la factura aquí: <a href=${window.location.origin}?db=${sapDB}&bill=${bill}>aquí</a>.`;
			await sendMail("contabilidad@bailacthor.com", `La factura ${bill} ha sido rechazada.`, body);

			onRefresh();
			onClose();

		} catch (error) {
			console.error('Error rejecting invoice:', error);
		}

	}


	return (
		<form>
			<orm-modal>
				<dialog open>
					<h2>Rechazando factura</h2>
					<table>
						<tbody>
							<tr>
								<td>Razón:</td>
								<td><textarea onChange={(e) => setReas(e.target.value)} className={error ? 'error' : ''}>{error}</textarea></td>
							</tr>
						</tbody>
					</table>
					<table>
						<tfoot>
							<tr>
								<td></td>
								<td>
									<input type="button" value="Cancelar" onClick={onClose} />
									<input type="button" value="Rechazar" onClick={declineInvo} />
								</td>
							</tr>
						</tfoot>
					</table>
				</dialog>
			</orm-modal>
		</form>
	);

}


export default RejeInvo;